import pressureUtils from "@/utils/pressure"

export default (value, units) => {
  if (value !== undefined && value != null) {
    return pressureUtils.convertFromBar(value, units)
  }
  return value
}
